'use strict';

const chatUtils = require('../../utils/social/chat');

/**
 * Rule to start chat
 */
const outboundRule = () => {
    chatUtils.start();
    return Promise.resolve();
};

module.exports = outboundRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/chatRule.es.js